import type { GetStaticPaths, GetStaticProps } from 'next'
import type { ComponentProps } from 'react'

import { type WebsiteLocale, BASE_WEBSITE_LOCALES } from '@/types/locales'

import { GutHealthTestPDPPage } from '@/components/pages/buyguthealthtest/GutHealthTestPDPPage'

import { getGutHealthTestPdpContent } from '@/lib/api/graphql/GutHealthTestPDP'

type Props = ComponentProps<typeof GutHealthTestPDPPage>
type PathParams = { locale: WebsiteLocale }

export default GutHealthTestPDPPage

export const getStaticProps: GetStaticProps<Props, PathParams> = async ({ params, preview = false }) => {
  const locale = params?.locale

  if (!locale || !BASE_WEBSITE_LOCALES.includes(locale)) {
    return { notFound: true }
  }

  const page = await getGutHealthTestPdpContent(locale, preview)

  if (!page) {
    return { notFound: true }
  }

  return {
    props: { page },
  }
}

export const getStaticPaths: GetStaticPaths<PathParams> = () => {
  return {
    paths: BASE_WEBSITE_LOCALES.map((locale) => ({ params: { locale } })),
    fallback: false,
  }
}
